module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Light.81cd217e.ttf";